// Copy right - © 2024 tecera gmbh


export function get_scrollbar_width() {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

// utility function to find the main meter of a compound incase we need location or smth similiar
export function find_main_meter(compound_water_meter) {
    let main_meter = compound_water_meter.watermeterconfigs.find(meter => meter.compound_role === "main" || meter.compound_role === "single");
    return main_meter;
}


// Presses Button when element is focused and enter gets pressed
export function enter_to_click(node, button) {
    function handleKeyup(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            button.click();
        }
    }

    node.addEventListener("keyup", handleKeyup);

    return {
        destroy() {
            node.removeEventListener("keyup", handleKeyup);
        }
    };
}

export function sort_devices_by_order(list, order) {
    return list.slice().sort((a, b) => {
        let a_idx = order.indexOf(a.id);
        let b_idx = order.indexOf(b.id);

        // If not found, set index to a large number so it sorts to the end
        if (a_idx === -1) a_idx = Number.MAX_SAFE_INTEGER;
        if (b_idx === -1) b_idx = Number.MAX_SAFE_INTEGER;

        return a_idx - b_idx;
    });
}

// Drag and Drop Stuff

export function buffer_devices_order(new_list_order, filtered_devices) {
    new_list_order = filtered_devices.map((device) => device.id);
}

export function handle_consider_devices(event, filtered_devices) {
    filtered_devices = event.detail.items;
}

export function handle_finalize_devices(event, device_changed_flag, filtered_devices) {
    filtered_devices = event.detail.items;
    device_changed_flag = true;
    buffer_devices_order();
}
